export const alphaRegex = /[a-zA-Z\x00-\x7F\u0080-\uFFFF]+/
export const einRegex = /^[0-9]{2}\-?\d{7}$/
// emailRegex is inspired by the regexes provided at the following URL, with
// tweaks made to improve coverage of the test scenarios in emailYup.test.js
// https://stackoverflow.com/a/1373724
export const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+)(?:[A-Z0-9-]{1,62})[A-Z0-9]$/i
export const npiRegex = /^\d{10}$/
export const medicareNumberRegex = /^(?!0000)[a-zA-Z0-9]{4}[ -]?(?!000)[a-zA-Z0-9]{3}[ -]?(?!0000)[a-zA-Z0-9]{4}$/
export const medicaidNumberRegex = /^[a-zA-Z0-9]{0,15}$/
export const phoneRegex = /^\d{3}[- ]?\d{3}[- ]?\d{4}$/
export const ssnRegex = /^(?!000)(?!666)(?!9)[0-9]{3}[ -]?(?!00)[0-9]{2}[ -]?(?!0000)[0-9]{4}$/
export const zipRegex = /^\d{5}$/
